import React from 'react';
import { Link } from 'react-router-dom';
import { CCard, CAccordion, CAccordionItem, CAccordionHeader, CAccordionBody } from '@coreui/react';

const SupportRequestRelevantQa = ({ relevantQa }) => {
	if (!relevantQa || relevantQa.length === 0) return null;

	return (
		<CCard className="mb-4">
			<CAccordion>
				<CAccordionItem itemKey={1}>
					<CAccordionHeader><strong>Релевантні Q&A (топ-5)</strong></CAccordionHeader>
					<CAccordionBody className="p-3">
						{relevantQa.map(qa => (
							<div key={qa.id} className="mb-3 p-2 border rounded">
								<div className="fw-semibold">
									<Link to={`/qa/view/${qa.id}`}>#{qa.id} {qa.question}</Link>
								</div>
								<div className="text-muted small mt-1" style={{ whiteSpace: 'pre-wrap' }}>
									{qa.answer?.slice(0, 200)}{qa.answer?.length > 200 ? '...' : ''}
								</div>
							</div>
						))}
					</CAccordionBody>
				</CAccordionItem>
			</CAccordion>
		</CCard>
	);
};

export default SupportRequestRelevantQa;
